import Script from 'next/script'

interface BreadcrumbMicrodataProps {
  data: { label: string | undefined; link: string }[]
  basePath: string
}

export default function BreadcrumbMicrodata({
  data,
  basePath
}: BreadcrumbMicrodataProps) {
  const idJsonObject = {
    '@context': 'http://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        item: {
          '@id': `${basePath}/`,
          name: 'Accueil'
        }
      },
      ...data.map(({ label, link }, index) => ({
        '@type': 'ListItem',
        position: index + 2,
        item: {
          '@id': `${basePath}${link}`,
          name: label
        }
      }))
    ]
  }

  return (
    <Script
      id="breadcrumb-script"
      strategy="beforeInteractive"
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(idJsonObject) }}
    />
  )
}
